import { BaseComponent } from "../../Library/BaseComponent";
import { OnInit, Component, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { MasterDataService } from "../../Services/MasterDataService";
import { PropertyBasicInfo } from "../../Models/GlobalEntities";
import { TopFilterStatModel } from "../../Models/CommonModels";
import { QuestionnaireSearchResult } from "../QuestionnaireSearchResult/QuestionnaireSearchResult";
import { QuestionnairePopover } from "../QuestionnairePopover/QuestionnairePopover";
import { StaffQuestionaireTemplate } from "../../Models/ResponseModels";
import { StaffHealthDataService } from "../../Services/StaffHealthDataService";
import { QuestionSetStatus, AuthActionCodes } from "../../Models/EnumModels";
import { AppSettings } from "../../Library/AppSettings";

@Component({
    selector: 'QuestionnaireConsole',
    templateUrl: './QuestionnaireConsole.html'
})
export class QuestionnaireConsole extends BaseComponent implements OnInit {

    @ViewChild('grdSearchResult') searchResult: QuestionnaireSearchResult;
    @ViewChild('detailPopover') detailPopover: QuestionnairePopover;

    RequestModel: any = {};
    FilterModel = {
        KeywordSearch: null,
        SelectedTabId: null
    };

    SelectedQuestionSet?: StaffQuestionaireTemplate;

    lstProperties: Array<PropertyBasicInfo> = [];
    PropStatModel: Array<TopFilterStatModel> = [];
    SelectedPropertyName: string;
    KeywordSearch: string = null;
    EditModel?: StaffQuestionaireTemplate;
    EditMode: 'edit' | 'clone' | undefined;
    AppSettings = AppSettings;

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected staffHealthService: StaffHealthDataService) {
        super(translate, toastr, route, router, masterService);

        this.lstProperties = this.masterService.GetProperties_Action(
            AuthActionCodes.StaffHealth_MANAGE
        );

        this.populateTopFilters();
    }

    populateTopFilters(counts: any = {}): void {
        this.PropStatModel = [];
    }

    ngOnInit() {
        var selectedPropertyId: number;
        if (
            this.lstProperties.findIndex(
                a => a.PropertyId == this.masterService.ActivePropertyID
            ) > 0
        )
            selectedPropertyId = this.masterService.ActivePropertyID;
        else {
            if (this.lstProperties.length > 0)
                selectedPropertyId = this.lstProperties[0].PropertyId;
        }
        this.onPropertyChange(this.masterService.GetProperty(selectedPropertyId));
    }

    onSelected(event: StaffQuestionaireTemplate) {
        this.SelectedQuestionSet = event;
    }

    didTakeActionOnQuestionSet(event) {
        const { action, model } = event;
        if (!action || !model) {
            return;
        }

        this.EditMode = undefined;

        if (action == 'close') {
            //this.SelectedQuestionSet = null;
            //this.searchResult.SelectedQuestionSet = null;
            this.searchResult.onRowSelected(null);
            return;
        }

        if (action == 'edit' || action == 'clone') {
            this.EditModel = model;
            //this.SelectedQuestionSet = null;
            //this.searchResult.SelectedQuestionSet = null;
            this.searchResult.onRowSelected(null);
            this.EditMode = action;
            return;
        }


        if (action == 'activate' || action == 'deactivate') {
            const updatedStatus = action == 'activate' ? QuestionSetStatus.Active : QuestionSetStatus.Disabled;
            this.staffHealthService
                .ChangeQuestionaireStatus({
                    Status: updatedStatus,
                    QuestionaireId: model.Id,
                    PropertyId: model.PropertyId
                })
                .then(data => {
                    if (data.HasError) {
                        return;
                    }
                    this.toastr.success('Question status updated successfully');
                    this.refresh();
                }, error => {
                    console.error(error);
                })
        }
    }

    didTakeEditWindowAction(action: string) {
        // dismiss window on any action
        if (action) {
            this.EditModel = null;
        }
        // if questionnaire was activated from edit window or copy was made
        // then refresh data
        if (action == 'questionnaire_activate_success' || action == 'questionnaire_submit_success' ) {
            this.refresh()
        }
        // reset edit mode
        this.EditMode = undefined;
    }

    onPropertyChange(row: PropertyBasicInfo) {
        this.RequestModel.PropertyId = row.PropertyId;
        this.SelectedPropertyName = row.PropertyName;
        this.refresh();
    }

    refresh() {
        this.searchResult.setRequestModel(Object.assign({}, this.RequestModel));
    }

    onSearchTextChange(event) {
        if (!this.FilterModel) {
            return;
        }
        this.FilterModel = {
            ...this.FilterModel,
            ... {
                KeywordSearch: this.KeywordSearch
            }
        }
    }

    onTopFilterChange(tab: TopFilterStatModel) {
        if (!(tab && this.FilterModel)) {
            return;
        }
        this.FilterModel = {
            ...this.FilterModel,
            ... {
                SelectedTabId: tab.Id
            }
        }
    }

    didUpdateCount(counts) {
        this.populateTopFilters(counts);
    }
}
